//TODO translate and replace this with the generic Size enum
export enum SpinnerSize {
  EXTRA_SMALL = 18,
  SMALL = 24,
  MEDIUM = 40,
  LARGE = 60,
  EXTRA_LARGE = 80
}
